'use client';

import Icon from './Icon';
import svg from 'sprites/human-pregnant.svg';

export default function IconHumanPregnant({
  className = 'w-13 h-8 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
